import React from "react";

const HidePassword = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <path d="M0 0H14V14H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8086 4.0971L12.8869 2.01874L12.2682 1.40002L9.95477 3.71347L8.56479 5.10345L7.98725 5.68099L5.57826 8.08998L5.00072 8.66752L3.43332 10.2349L1.75 11.9182L2.36872 12.537L4.31103 10.5946L5.64676 9.25891L6.24002 8.66566L8.55441 6.35126L9.14767 5.758L10.8086 4.0971ZM7 11.0432C6.23299 11.0432 5.48975 10.9383 4.78294 10.7415L6.05464 9.46975C6.34671 9.58828 6.66579 9.65353 7 9.65353C8.39741 9.65353 9.53029 8.51281 9.53029 7.10574C9.53029 6.77543 9.46786 6.4598 9.35424 6.17015L11.2068 4.31757C12.2781 4.94908 13.2038 5.81428 13.9194 6.84586C14.0269 7.00105 14.0269 7.21043 13.9194 7.36561C12.375 9.59192 9.85187 11.0432 7 11.0432ZM7 8.84287C6.89997 8.84287 6.80192 8.8343 6.70655 8.81784L8.70231 6.82208C8.71737 6.91439 8.7252 7.00914 8.7252 7.10574C8.7252 8.0651 7.95277 8.84287 7 8.84287ZM9.49637 3.55315L8.19181 4.85771C7.83667 4.66641 7.43091 4.55794 7 4.55794C5.60259 4.55794 4.46971 5.69866 4.46971 7.10574C4.46971 7.53337 4.57434 7.9364 4.75924 8.29028L3.02426 10.0253C1.85488 9.38479 0.847151 8.47067 0.0805669 7.36561C-0.0268556 7.21066 -0.0268556 7.00105 0.0805669 6.84609C1.62497 4.61955 4.14813 3.16824 7 3.16824C7.86875 3.16824 8.707 3.30291 9.49637 3.55315ZM7.58022 5.4693L5.37084 7.67867C5.30862 7.49929 5.2748 7.30649 5.2748 7.10574C5.2748 6.14638 6.04723 5.36861 7 5.36861C7.20356 5.36861 7.39889 5.40411 7.58022 5.4693Z"
          fill="black"
          fillOpacity="0.67"
        />
      </g>
    </svg>
  );
};

export default HidePassword;
